import { useRef } from 'react';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import styles from '@components/ProductCardNew/PromoLabels/PromoLabels.styles';
import CustomizeIcon from '@components/CustomizeIcon/CustomizeIcon';
import { TProductFlagsKey } from '@features/categories/typescript/index';
import { FLAGS_TYPES_NAMES } from '@features/categories/const';
import IsShopMiddleware from '@utils/IsShopMiddleware';
import theme from '@styles/theme';
type PropsType = {
  configurable: boolean;
  productUrl?: string;
  onConfigClick?: () => void;
  pricePromoPercent: string;
  checkFlagActive: (flagName: TProductFlagsKey) => boolean;
  isSmall?: boolean;
  transparent?: boolean;
  hasHoverImage?: boolean;
  /** Kursor nad całą kartą produktu — jak hover na przycisku „dostosuj”. */
  isCardHovered?: boolean;
  className?: string;
  isBlock?: boolean;
};
const Promolabels = ({
  configurable,
  productUrl,
  onConfigClick,
  pricePromoPercent,
  checkFlagActive,
  isSmall = false,
  transparent = false,
  hasHoverImage = false,
  isCardHovered = false,
  className,
  isBlock = false
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const configButtonRef = useRef<HTMLAnchorElement | HTMLDivElement>(null);
  const isNew = checkFlagActive(FLAGS_TYPES_NAMES.novelty) && !isBlock;
  const isNewOnlyBlock = checkFlagActive(FLAGS_TYPES_NAMES.novelty) && isBlock;
  const isHotSale = checkFlagActive(FLAGS_TYPES_NAMES.hotSale); // 1
  const isBuenFin = checkFlagActive(FLAGS_TYPES_NAMES.goodSale) && !isHotSale; // 2
  const isSurprise = checkFlagActive(FLAGS_TYPES_NAMES.surpriseSale) && !isHotSale && !isBuenFin; // 3
  const isPromo = pricePromoPercent && !isHotSale && !isBuenFin && !isSurprise || checkFlagActive(FLAGS_TYPES_NAMES.promotion);
  const isBlackFriday = checkFlagActive(FLAGS_TYPES_NAMES.blackFriday); // 1
  const isfastShipping = checkFlagActive(FLAGS_TYPES_NAMES.fastShipping) && !isBlackFriday; // 2
  const isBestseller = checkFlagActive(FLAGS_TYPES_NAMES.bestseller) && !isBlackFriday && !isfastShipping; // 3
  return <IsShopMiddleware>
      {configurable && (productUrl ? <Link ref={configButtonRef as React.RefObject<HTMLAnchorElement>} href={productUrl} onClick={onConfigClick} sx={styles.customizeButton(isSmall)} className={hasHoverImage ? 'product-config-button' : undefined} aria-label={t('customize')}>
            <CustomizeIcon hoverRef={configButtonRef as React.RefObject<HTMLElement | null>} background={transparent ? theme.rawColors.neutralWhite : theme.rawColors.lightGreyBgProduct} isCardHovered={isCardHovered} />
          </Link> : <div ref={configButtonRef as React.RefObject<HTMLDivElement>} sx={styles.customizeButton(isSmall)} className={hasHoverImage ? 'product-config-button' : undefined}>
            <CustomizeIcon hoverRef={configButtonRef as React.RefObject<HTMLElement | null>} background={transparent ? theme.rawColors.neutralWhite : theme.rawColors.lightGreyBgProduct} isCardHovered={isCardHovered} />
          </div>)}
      {(isBuenFin || isSurprise || isHotSale || isPromo || isBlackFriday || isfastShipping || isBestseller || isNewOnlyBlock) && <div sx={styles.rightLabels(isSmall)} role="group" aria-label={t('productPromotionalLabels')} className={className}>
          {isBuenFin && <span sx={styles.redLabel(isSmall)} role="status" aria-label={t('goodSale')}>
              {t('goodSale')}
            </span>}
          {isSurprise && <span sx={styles.redLabel(isSmall)} role="status" aria-label={t('surprise')}>
              {t('surprise')}
            </span>}
          {isHotSale && <span sx={styles.redLabel(isSmall)} role="status" aria-label={t('hotSale')}>
              {t('hotSale')}
            </span>}
          {isPromo && <span sx={styles.redLabel(isSmall)} role="status" aria-label={t('specialOffer')}>
              {t('specialOffer')}
            </span>}
          {isBlackFriday && <span sx={styles.blackLabel(isSmall)} role="status" aria-label={t('blackFriday')}>
              {t('blackFriday')}
            </span>}
          {isfastShipping && <span sx={styles.blackLabel(isSmall)} role="status" aria-label={t('fastShipping')}>
              {t('fastShipping')}
            </span>}
          {isBestseller && <span sx={styles.blackLabel(isSmall)} role="status" aria-label={t('bestseller')}>
              {t('bestseller')}
            </span>}
          {isNewOnlyBlock && <span sx={styles.whiteLabel(transparent, isSmall)} role="status" aria-label={t('new')}>
              {t('new')}
            </span>}
        </div>}
      {(pricePromoPercent || isNew) && <div sx={styles.bottomLabels} className={className ? `${className} bottom_labels` : 'bottom_labels'} role="group" aria-label={t('productAdditionalInformation')}>
          {pricePromoPercent && <span sx={styles.percentLabel(transparent)} role="status" aria-label={`${t('discount')}: ${pricePromoPercent}`}>
              {pricePromoPercent}
            </span>}
          {isNew && <span sx={styles.whiteLabel(transparent, isSmall)} role="status" aria-label={t('new')}>
              {t('new')}
            </span>}
        </div>}
    </IsShopMiddleware>;
};
export default Promolabels;